import { Controller } from "stimulus";

// The stream form's Audience section. A follower-open stream has no plan targeting, so while the switch
// is on the plan picker is hidden and disabled - auto-save skips disabled controls, and a real submit
// never sends them. Turning it on also puts the picker back to "All": the server clears the event's
// targeting on that same save, so the picker must not reappear later showing plans it no longer has.
export default class AudienceController extends Controller {
  static targets = ["followerToggle", "picker"];

  connect() {
    this.apply();
  }

  toggle() {
    if (this.followerToggleTarget.checked) this.resetPicker();
    this.apply();
  }

  apply() {
    const followerOpen = this.followerToggleTarget.checked;
    this.pickerTarget.hidden = followerOpen;
    this.pickerTarget.querySelectorAll("input, select, textarea").forEach((control) => {
      control.disabled = followerOpen;
    });
    // Tom Select keeps its own disabled state, read from the input when it initialises.
    const tom = this.planInput && this.planInput.tomselect;
    if (tom) {
      if (followerOpen) tom.disable();
      else tom.enable();
    }
  }

  // Back to "All" without an auto-save of its own: clear(true) is silent (no input/change on the
  // plan field), and the radio's change only re-renders TargetingComponent's label - its own
  // follow-up clear() returns early once nothing is selected.
  resetPicker() {
    if (this.planInput) {
      if (this.planInput.tomselect) this.planInput.tomselect.clear(true);
      this.planInput.value = "";
    }

    const all = this.pickerTarget.querySelector("input[type='radio'][value='all']");
    if (all) {
      all.checked = true;
      all.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  get planInput() {
    return this.pickerTarget.querySelector("[data-targeting-component-target='planSelect']");
  }
}
